// extracted by mini-css-extract-plugin
export default {"container":"Header_container__0OWAr","header":"Header_header__stqK6","logo":"Header_logo__uTM2S","icons_container":"Header_icons_container__hs9OG"};